import { createElement } from 'react';
import { Provider, connect } from 'react-redux';
import { createStore } from 'redux';
function defaultReducer(state) {
    return state;
}
/**
 * Creates new Pilet API extensions for creating a Redux state container.
 */
export function createReduxApi(config = {}) {
    const { reducer = defaultReducer, enhancer } = config;
    const otherReducers = {};
    const initialState = { stores: {} };
    const store = createStore(createReducer(), enhancer);
    const provider = createElement(Provider, { store });
    function createReducer() {
        return (state = initialState, action) => {
            switch (action.type) {
                case 'create-store': {
                    const stores = state.stores;
                    return {
                        ...state,
                        stores: {
                            ...stores,
                            [action.name]: action.value,
                        },
                    };
                }
                case 'destroy-store': {
                    const { [action.name]: _, ...stores } = state.stores;
                    return {
                        ...state,
                        stores: {
                            ...stores,
                        },
                    };
                }
                case 'change-store': {
                    const reducer = otherReducers[action.name];
                    const oldState = state.stores[action.name];
                    const newState = reducer(oldState, action.action);
                    if (oldState !== newState) {
                        return {
                            ...state,
                            stores: {
                                ...state.stores,
                                [action.name]: newState,
                            },
                        };
                    }
                    return state;
                }
                default: {
                    return reducer(state, action);
                }
            }
        };
    }
    return (context) => {
        context.includeProvider(provider);
        return (_, meta) => ({
            createReduxStore(reducer) {
                const name = meta.name;
                otherReducers[name] = reducer;
                store.dispatch({
                    type: 'create-store',
                    name,
                    value: reducer(undefined, { type: '$init' }),
                });
                const dispatch = (action) => ({
                    type: 'change-store',
                    name,
                    action,
                });
                return (component) => connect((state) => ({ state: state.stores[name] }), {
                    dispatch,
                })(component);
            },
        });
    };
}
//# sourceMappingURL=create.js.map